import { FC, ReactNode, useContext } from 'react'
import { styled } from '@mui/material/styles'
import { Alert, Box, Snackbar } from '@mui/material'
import { Outlet } from 'react-router-dom'

import Sidebar from './Sidebar'
import Header from './Header'
import { SidebarContext } from 'src/contexts/SidebarContext'
import { LOG_IN_METAMASK_MESSAGE } from 'src/utils/commons'
import { useTxStatusContext } from 'src/contexts/txStatusContext'

interface SidebarLayoutProps {
  children?: ReactNode
}

const MainWrapper = styled(Box)(
  ({ theme }) => `
        flex: 1 1 auto;
        display: flex;
        height: 100%;

        @media (min-width: ${theme.breakpoints.values.lg}px) {
            padding-left: ${theme.sidebar.width};
        }
`
)

const MainContent = styled(Box)(
  ({ theme }) => `
        margin-top: ${theme.header.height};
        flex: 1 1 auto;
        overflow: auto;
`
)

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const { connecYourtWalletSnackbarOpened, setConnectYourWalletSnackbarOpened } =
    useContext(SidebarContext)
  const {renderTxStatusAlert} = useTxStatusContext();

  const handleClose = () => {
    setConnectYourWalletSnackbarOpened(false)
  }

  return (
    <>
      <Sidebar />
      {renderTxStatusAlert?.()}
      <MainWrapper>
        <Header />
        <MainContent>
          <Outlet />
        </MainContent>
        <Snackbar
          open={connecYourtWalletSnackbarOpened}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          {/*@ts-ignore*/}
          <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
            {LOG_IN_METAMASK_MESSAGE}
          </Alert>
        </Snackbar>
      </MainWrapper>
    </>
  )
}

export default SidebarLayout
